// Images
import { Men, Women } from "../assets/images/svg";

export const eventTypeList = [
    {
        label: "Men Single",
        value: "MEN_SINGLE"
    },
    {
        label: "Women Single",
        value: "WOMEN_SINGLE"
    },
    {
        label: "Men Double",
        value: "MEN_DOUBLE"
    },
    {
        label: "Women Double",
        value: "WOMEN_DOUBLE"
    },
    {
        label: "Mix Double",
        value: "MIX_DOUBLE"
    },
    {
        label: "Men 3 on 3",
        value: "MEN_3_3"
    },
    {
        label: "Women 3 on 3",
        value: "WOMEN_3_3"
    },
    {
        label: "Mix 3 on 3",
        value: "MIX_3_3"
    },
    {
        label: "Group Captain",
        value: "GROUP_CAPTAIN"
    },
    {
        label: "Junior Double",
        value: "JUNIOR_DOUBLE"
    }
    // {
    //     label: "Group 7pax",
    //     value: "GROUP_7"
    // }
];

export const countryList = [
    "Malaysia",
    "Denmark",
    "China",
    "Thailand",
    "Singapore",
    "Indonesia",
    "Vietnam",
    "Philippines",
    "Cambodia",
    "India",
    "England",
    "Japan",
    "South Korea",
    "Taiwan",
    "Hong Kong",
    "Others"
]

/**
    * @function convertEventType
    * @params event
    * @description used to convert event
*/
export const convertEventType = (event) => {
    if (event) {
        switch (event) {
            case 'MEN_SINGLE':
                return 'Men Single'
            case 'WOMEN_SINGLE':
                return 'Women Single'
            case 'MEN_DOUBLE':
                return 'Men Double'
            case 'WOMEN_DOUBLE':
                return 'Women Double'
            case 'MIX_DOUBLE':
                return 'Mix Double'
            case 'MEN_3_3':
                return 'Men 3 on 3'
            case 'WOMEN_3_3':
                return 'Women 3 on 3'
            case 'MIX_3_3':
                return 'Mix 3 on 3'
            case 'JUNIOR_SINGLE':
                return 'Group Captain'
            case 'GROUP_CAPTAIN':
                return 'Group Captain'
            case 'JUNIOR_DOUBLE':
                return 'Junior Double'
            case 'GROUP_7':
                return 'Group 7pax'
            default:
                return ''
        }
    } else {
        return ''
    }
}

/**
    * @function convertAgeGroup
    * @params ageGroup, ageValue
    * @description used to convert age group
*/
export const convertAgeGroup = (ageGroup, ageValue) => {
    if (ageGroup) {
        switch (ageGroup) {
            case 'BELOW_AGE':
                return `Below ${parseInt(ageValue)}`
            case 'ABOVE_AGE':
                return `Above ${parseInt(ageValue)}`
            case 'TOTAL_BELOW_AGE':
                return `Total below ${parseInt(ageValue)}`
            case 'TOTAL_ABOVE_AGE':
                return `Total above ${parseInt(ageValue)}`
            case 'OPEN':
                return 'Open'
            case 'AMATEUR':
                return 'Amateur'
            case 'BAKAT_BARU':
                return 'Bakat Baru'
            case 'NOVICE':
                return 'Novice'
            case 'INTERMEDIATE':
                return 'Intermediate'
            case 'SEMI_PRO':
                return 'Semi-Pro'
            default:
                return ''
        }
    } else {
        return ''
    }
}

/**
    * @function convertGender
    * @params gender
    * @description used to convert gender
*/
export const convertGender = (gender) => {
    if (gender) {
        switch (gender) {
            case 'MALE':
                return 'Male'
            case 'FEMALE':
                return 'Female'
            default:
                return ''
        }
    } else {
        return ''
    }
}

/**
    * @function detectMenEvent
    * @params { event, color, className }
    * @description used to detect men event
*/
export const detectMenEvent = ({ event, color, className }) => {
    if (event) {
        switch (event) {
            case 'MEN_SINGLE':
            case 'MEN_DOUBLE':
            case 'MIX_DOUBLE':
            case 'MEN_3_3':
            case 'MIX_3_3':
            case 'JUNIOR_SINGLE':
            case 'GROUP_CAPTAIN':
            case 'JUNIOR_DOUBLE':
            case 'GROUP_7':
                return <Men color={color} className={className} />;
            default:
                return <></>;
        }
    } else {
        return <></>
    }
}

/**
    * @function detectWomenEvent
    * @params { event, color, className }
    * @description used to detect women event
*/
export const detectWomenEvent = ({ event, color, className }) => {
    if (event) {
        switch (event) {
            case 'WOMEN_SINGLE':
            case 'WOMEN_DOUBLE':
            case 'MIX_DOUBLE':
            case 'WOMEN_3_3':
            case 'MIX_3_3':
            case 'JUNIOR_SINGLE':
            case 'GROUP_CAPTAIN':
            case 'JUNIOR_DOUBLE':
            case 'GROUP_7':
                return <Women color={color} className={className} />;
            default:
                return <></>;
        }
    } else {
        return <></>
    }
}

/**
    * @function getPlayerCount
    * @params event
    * @description used to get player count for an event
*/
export const getPlayerCount = (event) => {
    if (event) {
        switch (event) {
            case 'MEN_SINGLE':
            case 'WOMEN_SINGLE':
                return 1;
            case 'MEN_DOUBLE':
            case 'WOMEN_DOUBLE':
            case 'MIX_DOUBLE':
            case 'JUNIOR_DOUBLE':
                return 2;
            case 'MEN_3_3':
            case 'WOMEN_3_3':
            case 'MIX_3_3':
                return 3;
            case 'GROUP_7':
                return 7;
            case 'JUNIOR_SINGLE':
            case 'GROUP_CAPTAIN':
                return 12;
            default:
                return 0;
        }
    } else {
        return 0;
    }
}

/**
    * @function getGenderCount
    * @params event
    * @description used to get gender count for an event 
*/
export const getGenderCount = (event) => {
    if (event) {
        switch (event) {
            case 'MEN_SINGLE':
                return {
                    number_of_males: 1,
                    number_of_females: 0
                };
            case 'WOMEN_SINGLE':
                return {
                    number_of_males: 0,
                    number_of_females: 1
                };
            case 'MEN_DOUBLE':
                return {
                    number_of_males: 2,
                    number_of_females: 0
                };
            case 'WOMEN_DOUBLE':
                return {
                    number_of_males: 0,
                    number_of_females: 2
                };
            case 'MIX_DOUBLE':
                return {
                    number_of_males: 1,
                    number_of_females: 1
                };
            case 'MEN_3_3':
                return {
                    number_of_males: 3,
                    number_of_females: 0
                };
            case 'WOMEN_3_3':
                return {
                    number_of_males: 0,
                    number_of_females: 3
                };
            default:
                return null;
        }
    } else {
        return null;
    }
};

/**
    * @function isSingleEvent
    * @params event
    * @description used to detect an event is single or not 
*/
export const isSingleEvent = (event) => {
    if (event) {
        switch (event) {
            case 'MEN_SINGLE':
            case 'WOMEN_SINGLE':
                return true;
            default:
                return false;
        }
    } else {
        return false;
    }
};

/**
    * @function isDoubleEvent
    * @params event
    * @description used to detect an event is double or not 
*/
export const isDoubleEvent = (event) => {
    if (event) {
        switch (event) {
            case 'MEN_DOUBLE':
            case 'WOMEN_DOUBLE':
            case 'MIX_DOUBLE':
            case 'JUNIOR_DOUBLE':
                return true;
            default:
                return false;
        }
    } else {
        return false;
    }
};

/**
    * @function isMixedEvent
    * @params event
    * @description used to detect an event is mixed or not 
*/
export const isMixedEvent = (event) => {
    if (event) {
        switch (event) {
            case 'MIX_3_3':
            case 'GROUP_7':
                return true;
            default:
                return false;
        }
    } else {
        return false;
    }
};

/**
    * @function isAgeValueRequired
    * @params ageGroup
    * @description used to detect age value is required for age group
*/
export const isAgeValueRequired = (ageGroup) => {
    if (ageGroup) {
        switch (ageGroup) {
            case 'OPEN':
            case 'AMATEUR':
            case 'BAKAT_BARU':
            case 'SEMI_PRO':
            case 'NOVICE':
            case 'INTERMEDIATE':
                return false;
            default:
                return true;
        }
    } else {
        return false;
    }
};

/**
    * @function getMaxGenderParticipants
    * @params event
    * @description used to get maximum participant number for an gender of an event
*/
export const getMaxGenderParticipants = (event) => {
    if (event) {
        switch (event) {
            case "MIX_3_3":
                return 2;
            case "GROUP_7":
                return 7;
            default:
                return 0;
        }
    } else {
        return 0;
    }
};

/**
    * @function getMinGenderParticipants
    * @params event
    * @description used to get minimum participant number for an gender of an event
*/
export const getMinGenderParticipants = (event) => {
    if (event) {
        switch (event) {
            case "MIX_3_3":
                return 1;
            default:
                return 0;
        }
    } else {
        return 0;
    }
};
